import { createContext, Dispatch, SetStateAction } from 'react';

import { EmptyResults, SearchResultsItem } from '@gn-audio/jss-core';

export interface ExtendedSearchResultsItem extends SearchResultsItem {
  isDiscontinued: boolean;
}

export interface ExtendedSearchResults {
  count: number;
  items: ExtendedSearchResultsItem[];
  error?: string;
}

export interface ISearchContext {
  searchResults: ExtendedSearchResults | EmptyResults;
  setSearchResults: Dispatch<SetStateAction<ExtendedSearchResults | EmptyResults>>;
  searchFilter: string;
}

export const SearchContext = createContext<ISearchContext>({
  setSearchResults: () => {},
  searchResults: { count: 0, items: [] },
  searchFilter: '',
});
